import { RootSignersModeEnum } from '../enums/RootSignersModeEnum';

interface IGetRootSignersModeParams {
  hasActs: boolean;
  isApproving: boolean;
  isCarriedOut: boolean;
  isCommentsExist: boolean;
  isFillInProcess: boolean;
  isPm: boolean;
  isReadyForApprove: boolean;
  isWaitingCarryOut: boolean;
}

/**
 * Режим корневых подписантов КНМ/ПМ по статусу (акты/решения не входят в расчёт здесь).
 */
export const getRootSignersMode = ({
  hasActs,
  isApproving,
  isCarriedOut,
  isCommentsExist,
  isFillInProcess,
  isPm,
  isReadyForApprove,
  isWaitingCarryOut,
}: IGetRootSignersModeParams): RootSignersModeEnum | undefined => {
  if (isCarriedOut) {
    return hasActs ? RootSignersModeEnum.READONLY_ALL : RootSignersModeEnum.MULTI_FIRST_LOCKED;
  }

  if (isFillInProcess) {
    return RootSignersModeEnum.SINGLE_AUTO;
  }

  if (isReadyForApprove || isCommentsExist) {
    return RootSignersModeEnum.MULTI_FIRST_LOCKED;
  }

  if (isWaitingCarryOut) {
    if (isPm) {
      return hasActs ? RootSignersModeEnum.READONLY_ALL : RootSignersModeEnum.MULTI_FIRST_LOCKED;
    }

    return RootSignersModeEnum.MULTI_FIRST_LOCKED;
  }

  if (isApproving) {
    return RootSignersModeEnum.READONLY_ALL;
  }

  return undefined;
};
